// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"OpointTextWithMatchesAndEntities_tooltipContainer__3ArqF","tooltipContentWrapper":"OpointTextWithMatchesAndEntities_tooltipContentWrapper__K2GmF"};